<template>
  <div class="mob-filters">
    <div class="mob-filters__wrap">
      <div class="mob-filters__head">
        <h2 class="section-title">Filters</h2>
        <svg @click="emitClose">
          <use xlink:href="#icon-times-light"></use>
        </svg>
      </div>
      <div class="mob-filters__body">
        <MobSingleFilter
            v-if="years"
            :title="Filter.YEAR"
            :filter="years"
        />
        <MobSingleFilter
            v-if="altitude"
            :title="Filter.ALTITUDE"
            :filter="altitude"
        />
        <MobSingleFilter
            v-if="media"
            :title="Filter.MEDIA"
            :filter="media"
        />
        <MobSingleFilter
            v-if="specifics"
            :title="Filter.SPECIFIC"
            :filter="specifics"
        />
        <div class="mob-filters__btn-wrap">
          <div @click="resetFilters" class="main-btn">Clear Filters</div>
          <div @click="emitClose" class="main-btn main-btn--gray">Close</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import MobSingleFilter from "./MobSingleFilter.vue";
import {useProductStore} from "../../../store/product.ts";
import {useCategoryStore} from "../../../store/category.ts";
import {Filter} from "../../../utils/types.ts";

const productStore = useProductStore();
const {resetFilters} = productStore;
const {years, altitude, media, specifics} = useCategoryStore();

const emit = defineEmits<{
  (e: 'close'): void
}>()

function emitClose() {
  emit('close')
}

</script>
